<template>
    <transition name="batch-actions-fade">
        <div v-if="selectedCount > 0" class="list-batch-actions" role="toolbar" :aria-label="$t('common.batchActions')">
            <div class="list-batch-selection">
                <span class="list-batch-count">{{selectedCount}}</span>
                <span>{{$t('common.selected')}}</span>
            </div>
            <div class="list-batch-buttons">
                <el-button v-for="action in actions" :key="action.key" size="small"
                           :type="action.danger ? 'danger' : 'default'" :loading="loadingAction === action.key"
                           :disabled="loadingAction !== '' && loadingAction !== action.key"
                           @click="$emit('action', action.key)">
                    <i v-if="action.icon" :class="action.icon"></i>
                    <span>{{action.label}}</span>
                </el-button>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            selectedCount: {
                type: Number,
                required: true
            },
            actions: {
                type: Array,
                required: true
            },
            loadingAction: {
                type: String,
                default: ''
            }
        }
    }
</script>
